var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pwc-app-wechat"},[(_vm.showAlertInfoOpenInWechat)?_c('p',[_vm._v("请在微信客户端打开链接")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }